import React, { Component } from 'react';
import { connect } from "react-redux";
import { Field, reduxForm, initialize } from 'redux-form';
import { updateShortcut, removeShortcut } from '../../redux/actions';

import { ShortField } from '../atoms/formElements/formElements';
import Button from '../atoms/button/button';
import SideModal from '../molecules/modal/sideModal';

class EditShortcuts extends Component {
  render() {
    const { state, initialValues, handleSubmit } = this.props;
    return (
      <SideModal active={state ? 'active' : null } screen='shortcuts' >
        <div id='sideModalWrapper'>
          <h1>{initialValues ? 'Edit' : 'Add' } shortcut</h1>
          <div className='shortcutsList'>
            <form model="initialValues">
              <Field name='title' label='Title' component={ShortField} type='text' />
              <Field name='link' label='Link' component={ShortField} type='text' />
              <Button label='Save' disabled='false' type='button' onClick={handleSubmit(values => this.props.updateShortcut(values))} />
              {initialValues && initialValues.title ? <Button label='Delete' disabled='false' type='button' state='bad' onClick={e => this.props.removeShortcut(e)} /> : null }
            </form>
          </div>
        </div>
      </SideModal>
    )

  }
}

const validate = values => { //validate function will automatically be called by redux-form
  const errors = {};
  if(!values.title) { errors.title = 'Required' }
  if(!values.link) { errors.link = 'Required' }
  return errors;
}

function mapStateToProps(state) {
  return {
    state: state.overlays.shortcuts,
    initialValues: state.general.activeShortcut,
  };

}

let InitializeFromStateForm = reduxForm({
  form: 'shortcutsForm',
  enableReinitialize : true,
  validate
})(EditShortcuts)


// You have to connect() to any reducers that you wish to connect to yourself
export default connect(mapStateToProps, { updateShortcut, removeShortcut})(InitializeFromStateForm)
